export function isAsapAuth(auth) {
    return !!auth.asap.issuer && !!auth.asap.keyId && !!auth.asap.privateKey;
}
export const CHECK_ADD_PROJECT_ACTION = 'addProduct';
export const CHECK_ADD_PROJECT_ARI_PREFIX = 'ari:cloud:platform::site/';
//# sourceMappingURL=identity-client.types.js.map